module.exports = __webpack_public_path__ + "img/analyzer_black.28055ec4.svg";